import { TrackedObject as AppTrackedObject } from '../types';
import { TrackedObject as ServiceTrackedObject, LocationUpdate } from '../services/ObjectsService';

/**
 * Converts a service TrackedObject to an application TrackedObject
 * The service and app use different formats, so we need to map between them
 */
export function mapServiceObjectToAppObject(
  serviceObject: ServiceTrackedObject,
  locationData?: LocationUpdate | null
): AppTrackedObject {
  const now = Date.now();
  const timestamp = locationData?.timestamp || now;
  
  return {
    id: serviceObject.id,
    name: serviceObject.name,
    description: serviceObject.description || '',
    lastUpdate: timestamp,
    latitude: locationData?.latitude || 37.7749, // Default to San Francisco if no location
    longitude: locationData?.longitude || -122.4194,
    isActive: (now - timestamp) < 5 * 60 * 1000 // Less than 5 minutes old
  };
}

/**
 * Maps an array of service objects to app objects
 */
export function mapServiceObjectsToAppObjects(
  serviceObjects: ServiceTrackedObject[],
  locationMap?: Map<string, LocationUpdate>
): AppTrackedObject[] {
  return serviceObjects.map(obj => {
    const locationData = locationMap?.get(obj.id);
    return mapServiceObjectToAppObject(obj, locationData);
  });
}
